// import React from "react";
// import { Navigate } from "react-router-dom";

// const PrivateRoute = ({ children }) => {
//     const token = localStorage.getItem("token"); // Check if user is authenticated
//     return token ? children : <Navigate to="/login" state={{ from: "/checkout" }} />;
// };

// export default PrivateRoute;


import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const PrivateRoute = ({ children, allowedRoles = [] }) => {
  const token = localStorage.getItem("token"); // Check authentication
  const role = localStorage.getItem("role"); // Get user role
  const location = useLocation();

  if (!token) {
    // Redirect to login if user is not authenticated
    return <Navigate to="/login" state={{ from: location.pathname }} />;
  }

  if (allowedRoles.length && !allowedRoles.includes(role)) {
    // Redirect to unauthorized page if role is not allowed
    return <Navigate to="/unauthorized" />;
  }

  return children; // Render children if access is valid
};

export default PrivateRoute;
